export const LangTexts = {
  en: {
    loggedText: 'My Movies',
  },
  'pt-BR': {
    loggedText: 'Meus Filmes',
  },
};
